module.exports = __webpack_public_path__ + "img/icon_edit.fca9c30b.svg";